export const EVENT = {
    GAMIFICATION: {
        // GAMIFICATION_CARD_CLICKED: 'gamification_card_clicked',
        // REWARDS_DASHBORAD_VIEWED: 'rewards_dashboard_viewed',
        GAMIFICATION_CARD_CLICKED: 'Gamification Card - Clicked',
        REWARDS_DASHBORAD_VIEWED: 'Rewards Dashboard - Viewed',
        MOVIES_AND_SHOWS: 'Movies and Shows - Clicked',
        LIVE_TV: 'Live TV - Clicked',
        TVOD_RENT: 'TVOD Rent - Clicked',
        SUBSCRIPTION_UPGRADE_CHOSEN: 'Subscription Upgrade - Chosen',
        REWARDS_VIEWED: 'Rewards Screen - Viewed',
        REDEEM_REWARD_CLICKED: 'Redeem Reward - Clicked',
        REDEEM_REWARD_INITIATED: 'Redeem Points - Initiated',
    },
};

export const GamificationRewardProperties = {
    tier_upgrade: EVENT.GAMIFICATION.SUBSCRIPTION_UPGRADE_CHOSEN,
    tvod_rent: EVENT.GAMIFICATION.TVOD_RENT,
    renew_subscription: EVENT.GAMIFICATION.SUBSCRIPTION_UPGRADE_CHOSEN,
    tvod_purchased: EVENT.GAMIFICATION.TVOD_RENT,
    vod_watched: EVENT.GAMIFICATION.MOVIES_AND_SHOWS,
    watch_live_tv: EVENT.GAMIFICATION.LIVE_TV,
};
